export const endpoint = process.env.NODE_ENV === 'production' ? window.baseURL : 'http://localhost:3001';
export const basename = window.context || '';
